import React from "react";
import SVGIcon from "../../components/Utils/svgIcons";
import {
  Row,
  Col
} from "reactstrap";
class FichaInfo extends React.Component {
  render() {
    if (this.props.items && this.props.items.length > 0) {
      let record=this.props.items[0];
      return (
        <div className="charts-container-section box-text">
          <div className="ml-2 mr-2">
          <Row>
            <Col>
              <span className="text-primary font-weight-bold">
                Nombre
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-secondary">
               <p className="text-justify">{record.nombre}</p>
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-primary font-weight-bold">
                Descripción
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-secondary ">
               <p className="text-justify">{record.descripcion}</p>
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-primary font-weight-bold">
                Finalidad
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-secondary">
               <p className="text-justify">{record.finalidad}</p>
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-primary font-weight-bold">
                Limitaciones
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-secondary">
               <p className="text-justify">{record.limitaciones}</p>
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-primary font-weight-bold">
                Metodología
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-secondary">
               <p className="text-justify">{record.metodologia}</p>
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-primary font-weight-bold">
                Elaborado por
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="text-secondary">
              <p className="text-justify">{record.fuente}</p>
              </span>
            </Col>
          </Row>
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default FichaInfo;
